// src/components/FilterBar.jsx

import React, { useState, useEffect } from 'react';
// ⛔ Ya no necesitamos CalendarIcon, Calendar, Popover
import { Loader2 } from 'lucide-react';
// import { format } from 'date-fns'; // ⛔ Ya no se usa
// import { es } from 'date-fns/locale'; // ⛔ Ya no se usa

// --- Rutas relativas corregidas ---
import { api } from '../utils/apiClient';
import { cn } from '../lib/utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';


// --- ⬇️ DATOS PARA FILTROS DE FECHA ⬇️ ---
const MESES = [
  { nombre: 'Enero', valor: '1' },
  { nombre: 'Febrero', valor: '2' },
  { nombre: 'Marzo', valor: '3' },
  { nombre: 'Abril', valor: '4' },
  { nombre: 'Mayo', valor: '5' },
  { nombre: 'Junio', valor: '6' },
  { nombre: 'Julio', valor: '7' },
  { nombre: 'Agosto', valor: '8' },
  { nombre: 'Septiembre', valor: '9' },
  { nombre: 'Octubre', valor: '10' },
  { nombre: 'Noviembre', valor: '11' },
  { nombre: 'Diciembre', valor: '12' },
];


// --- ✅ NUEVO: ARRAY DE DÍAS ---
const DIAS = Array.from({ length: 31 }, (_, i) => String(i + 1));


// --- ⬇️ LÓGICA DE CARGA DE FILTROS ⬇️ ---
export const FilterBar = ({ filters, setFilters }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [abogados, setAbogados] = useState([]);
  const [tiposServicio, setTiposServicio] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [anios, setAnios] = useState([]);

  useEffect(() => {
    // Función para cargar y procesar los filtros
    const fetchFilterData = async () => {
      try {
        setIsLoading(true);

        // 1. Hacemos fetch a todas las fuentes en paralelo
        const [casosData, facturasData, aniosData] = await Promise.all([
          api.get('/casos'),
          api.get('/factura'),
          api.get('/dashboard/anios_disponibles'),
        ]);

        // 2. Extraemos los datos de ambas fuentes
        const allAbogados = [
          ...casosData.map(c => c.abogado),
          ...facturasData.map(f => f.abogado)
        ];
        const allTiposServicio = [
          ...casosData.map(c => c.tipo_servicio),
          ...facturasData.map(f => f.tipo_servicio)
        ];
        const allClientes = [
          ...casosData.map(c => c.cliente_corporativo),
          ...facturasData.map(f => f.cliente_corporativo)
        ];

        // 3. Limpiamos (eliminamos duplicados y valores vacíos/nulos)
        setAbogados([...new Set(allAbogados)].filter(Boolean));
        setClientes([...new Set(allClientes)].filter(Boolean));

        // --- CAMBIO AQUÍ: FILTRAMOS "OTROS" DEL MENÚ DESPLEGABLE ---
        setTiposServicio(
          [...new Set(allTiposServicio)]
            .filter(Boolean)
            .filter(tipo => tipo !== 'OTROS')
        );
        setAnios(Array.isArray(aniosData) ? aniosData : []);

      } catch (error) {
        console.error("Error cargando filtros:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFilterData();
  }, []); // El array vacío [] asegura que esto se ejecute SOLO UNA VEZ al montar

  // --- ✅ LÓGICA DE FILTROS JERÁRQUICA (MEJORADA) ---
  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      const newFilters = { ...prev, [key]: value };

      // Lógica de reseteo jerárquico
      if (key === 'anio') {
        // Si cambia el año, resetea mes y día
        newFilters.mes = '';
        newFilters.dia = '';
      } else if (key === 'mes') {
        // Si cambia el mes, resetea solo el día
        newFilters.dia = '';
      }
  
      return newFilters;
    });
  };

  const triggerClass = "bg-slate-800 border-slate-700 text-slate-100 hover:bg-slate-750 focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500/70 rounded-xl text-xs h-9";
  const contentClass = "bg-slate-800 border-slate-700 text-slate-100";
  const labelClass = "block text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-1.5";

  return (
    <div className="rounded-2xl bg-slate-800/40 border border-slate-700/40 p-4">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold text-slate-400">Filtros del Dashboard</span>
        {isLoading && (
          <div className="flex items-center gap-1.5 text-slate-500 text-xs">
            <Loader2 size={12} className="animate-spin" />
            Cargando filtros...
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-3">

        {/* Cliente */}
        <div>
          <label className={labelClass}>Cliente</label>
          <Select
            disabled={isLoading}
            value={filters.cliente}
            onValueChange={(value) => handleFilterChange('cliente', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={triggerClass}>
              <SelectValue placeholder="Todos los Clientes" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="todos">Todos los Clientes</SelectItem>
              {clientes.map((cliente) => (
                <SelectItem key={cliente} value={cliente}>{cliente}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Abogado */}
        <div>
          <label className={labelClass}>Abogado</label>
          <Select
            disabled={isLoading}
            value={filters.abogado}
            onValueChange={(value) => handleFilterChange('abogado', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={triggerClass}>
              <SelectValue placeholder="Todos los Abogados" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="todos">Todos los Abogados</SelectItem>
              {abogados.map((abogado) => (
                <SelectItem key={abogado} value={abogado}>{abogado}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

                {/* Tipo de Servicio */}
        <div>
          <label className={labelClass}>Servicio</label>
          <Select
            disabled={isLoading}
            value={filters.tipoServicio}
            onValueChange={(value) => handleFilterChange('tipoServicio', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={triggerClass}>
              <SelectValue placeholder="Todos los Servicios" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="todos">Todos los Servicios</SelectItem>
              {tiposServicio.map((tipo) => (
                <SelectItem key={tipo} value={tipo}>{tipo}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Aseguradora */}
        <div>
          <label className={labelClass}>Aseguradora</label>
          <Select
            disabled={isLoading}
            value={filters.aseguradora || 'TODAS'}
            onValueChange={(value) => handleFilterChange('aseguradora', value)}
          >
            <SelectTrigger className={triggerClass}>
              <SelectValue placeholder="Todas las Aseguradoras" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="TODAS">Todas</SelectItem>
              <SelectItem value="IKE">IKE</SelectItem>
              <SelectItem value="Assisprex">Assisprex</SelectItem>
              <SelectItem value="MULTIASISTENCIA">MULTIASISTENCIA</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Año */}
        <div>
          <label className={labelClass}>Año</label>
          <Select
            disabled={isLoading}
            value={filters.anio}
            onValueChange={(value) => handleFilterChange('anio', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={triggerClass}>
              <SelectValue placeholder="Todos los Años" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="todos">Todos los Años</SelectItem>
              {anios.map((anio) => (
                <SelectItem key={anio} value={String(anio)}>{anio}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Mes */}
        <div>
          <label className={labelClass}>Mes</label>
          <Select
            disabled={isLoading || !filters.anio}
            value={filters.mes}
            onValueChange={(value) => handleFilterChange('mes', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={cn(triggerClass, !filters.anio && 'opacity-40 cursor-not-allowed')}>
              <SelectValue placeholder="Seleccione Mes" />
            </SelectTrigger>
            <SelectContent className={contentClass}>
              <SelectItem value="todos">Todos los Meses</SelectItem>
              {MESES.map((mes) => (
                <SelectItem key={mes.valor} value={mes.valor}>{mes.nombre}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Día */}
        <div>
          <label className={labelClass}>Día</label>
          <Select
            disabled={isLoading || !filters.mes}
            value={filters.dia}
            onValueChange={(value) => handleFilterChange('dia', value === 'todos' ? '' : value)}
          >
            <SelectTrigger className={cn(triggerClass, !filters.mes && 'opacity-40 cursor-not-allowed')}>
              <SelectValue placeholder="Seleccione Día" />
            </SelectTrigger>
            <SelectContent className={cn(contentClass, 'max-h-60')}>
              <SelectItem value="todos">Todos los Días</SelectItem>
              {DIAS.map((dia) => (
                <SelectItem key={dia} value={String(dia)}>{dia}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

      </div>
    </div>
  );
};